import { render, staticRenderFns } from "./dizhiForm.vue?vue&type=template&id=81d7f0ba&scoped=true&"
import script from "./dizhiForm.vue?vue&type=script&lang=js&"
export * from "./dizhiForm.vue?vue&type=script&lang=js&"
import style0 from "./dizhiForm.vue?vue&type=style&index=0&id=81d7f0ba&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d7f0ba",
  null
  
)

export default component.exports